import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { DataFlowSchemaAdapterUtils } from '../dataflow-schema-adapter-utils';
import { CastTransformation } from 'app/model/dataflow/casttransformation';
import { DataFlowLoggingService } from 'app/authoring/services/dataflow-logger.service';
import { DataFlowAdapterUtils } from '../adapter.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CastTransformation),
    asynchronous: true
})
export class CastTransformationAdapter extends TransformationAdapter<CastTransformation> {
    public async getDslScript(castTransformation: CastTransformation): Promise<string> {
        const props: string[] = [
            DataFlowSchemaAdapterUtils.getOutputDefinitionDslForColumns(castTransformation.castColumns),
            `errors: ${castTransformation.errors}`
        ];
        await DataFlowLoggingService.logColumnInfos(
            this.context.contextData,
            castTransformation.columns,
            castTransformation.name,
            Metamodel.modelFor(CastTransformation).name,
            castTransformation.owner.name
        );

        const knownProps = props.filter((prop) => !!prop).join(',\n\t');
        const unknownProps = DataFlowAdapterUtils.getUnknownProps(castTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');
        const outputStream = castTransformation.outputStream;
        return `${this._getInputStreams(castTransformation)} ${
            CastTransformation.MODEL.name
        }(${transformationData}) ${FLOW} ${outputStream ? outputStream.qualifiedName : ''}`;
    }
}
